import { ValidationErrorsDisplayComponent } from './validation-errors-display/validation-errors-display.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TooltipRef } from '../../zalamo-tooltip/tooltip-ref';
import { ZalamoTooltipService } from '../../zalamo-tooltip/zalamo-tooltip.service';
import { AliveState } from '../../../core/ActiveState';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { ValidationHelperService } from './validation-helper.service';
import { Injectable } from '@angular/core';

export declare interface HasValidationInterface {
  me: any;

  validationService: ValidationHelperService;

  validate(
    event: { target: HTMLElement },
    model: UntypedFormGroup | UntypedFormControl,
  ): boolean;
}

@Injectable()
export abstract class HasValidation extends AliveState {
  submitted = false;
  lastValidationInitiator;
  currentErrorsRef: TooltipRef<ValidationErrorsDisplayComponent> = null;
  private modelWatched = false;

  constructor(
    public tooltipService: ZalamoTooltipService,
    public validationService: ValidationHelperService,
  ) {
    super();
  }

  watchModel(model: UntypedFormGroup) {
    if (this.modelWatched) {
      return;
    }
    this.modelWatched = true;
    this.subscribeWhileAlive(
      model.valueChanges.pipe(
        filter(() => !!this.currentErrorsRef),
        debounceTime(500),
        tap(() => this.validate(this.lastValidationInitiator, model)),
      ),
    );
  }

  ngOnDestroy() {
    if (this.currentErrorsRef) {
      this.currentErrorsRef.close();
    }
  }

  validate(event, model: UntypedFormGroup) {
    // console.log('VALIDATING');
    this.watchModel(model);
    this.submitted = true;
    this.lastValidationInitiator = event;
    const invalid = [];

    const state = this.validationService.getState(model);
    for (const control in state) {
      // console.log(control, state[control].dom.parentNode);
      if (!document.body.contains(state[control].dom)) {
        delete state[control];
        continue;
      }
      const singleControl = state[control];
      singleControl.control?.markAllAsTouched();

      // console.log(control, state[control]);
      if (singleControl.control.invalid) {
        invalid.push({ control: singleControl.control, name: control });
      }
    }

    if (invalid.length) {
      if (!this.currentErrorsRef && this.tooltipService) {
        this.currentErrorsRef = this.tooltipService.open(
          ValidationErrorsDisplayComponent,
          'above',
          event.target,
          { sticky: true },
        );
        this.currentErrorsRef
          .afterClosed()
          .toPromise()
          .then(() => (this.currentErrorsRef = null));
      }
      if (this.currentErrorsRef?.componentInstance) {
        this.currentErrorsRef.componentInstance.context = {
          component: this,
          model,
        };
      }
    }
    if (!!this.currentErrorsRef && this.currentErrorsRef.componentInstance) {
      this.currentErrorsRef.componentInstance.invalidFields = invalid;
    }

    return invalid.length === 0;
  }
}
